<!--
 * @Author: your name
 * @Date: 2020-10-23 14:03:26
 * @LastEditTime: 2020-10-29 09:39:19
 * @LastEditors: Please set LastEditors
 * @Description: 收藏夹详情
 * @FilePath: /zhulogic-design-cloud-next/src/views/personal/common/work-collection-dialog.vue
-->
<template>
  <Modal
    v-model="model"
    :title="title"
    :mask-closable="false"
    :width="725"
    @on-cancel="cancel"
  >
    <div class="work-collection-dialog">
      <Row v-if="!loading" type="flex" class="collectList">
        <div
          v-if="collectionLists && collectionLists.length > 0"
          class="collect-item"
          v-for="item in collectionLists"
          :key="item.id"
          @click="chosedItem(item)"
        >
          <div class="img">
            <z-panelimg
              v-if="item.coverFile"
              class="coverImg"
              :del="false"
              :src="ossPrefix + item.coverFile.key"
            ></z-panelimg>
          </div>
        </div>
        <div
          style="text-align: center;width: 100%;margin-top: 200px;"
          v-if="!collectionLists || collectionLists.length === 0"
        >
          <img
            style="width: 157px;height: 143px;"
            src="@/assets/moon.png"
            alt=""
          />
          <p
            style="margin-top: 30px;font-size: 14px;font-weight: 400;color: #999999;"
          >
            收藏夹没有内容哦！
          </p>
        </div>
      </Row>
      <div v-if="loading" style="margin-top:100px">
        <div class="align-center">
          <img style="width:100px;" src="@/assets/new-global.gif" alt="" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      model: false,
      loading: false,
      collectionLists: [],
      title: '作品集详情',
    }
  },
  methods: {
    open(id, item) {
      this.model = true
      this.title = item.name
      this.getCollectLists(id, item.favoriteId)
    },
    cancel() {
      this.model = false
    },
    // 获得收藏夹列表
    getCollectLists(id, favoriteId) {
      this.loading = true
      axios
        // .get(`/designer_api/collection/${id}/collected_resources/v2`)
        .get(`/designer_api/job_resume/${id}/favorite/${favoriteId}`)
        .then((res) => {
          this.collectionLists = res.list
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 选择
    chosedItem(item) {
      if (this.choisedCollection.indexOf(item) > -1) {
        let index = this.choisedCollection.indexOf(item)
        this.choisedCollection.splice(index, 1)
        this.$set(item, 'choiced', false)
      } else {
        this.$set(item, 'choiced', true)
        this.choisedCollection.push(item)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.work-collection-dialog {
  height: 600px;
  overflow: auto;
  margin-top: -40px;
  .collect-item {
    width: 130px;
    position: relative;
    padding: 5px;
    cursor: pointer;
    .img {
      width: 120px;
      height: 120px;
      border-radius: 4px;
      background: rgb(189, 163, 163);
      position: relative;
      overflow: hidden;
      .coverImg {
        width: 120px;
        height: 120px;
        object-fit: cover;
      }
    }
    .content {
      padding: 15px 13px 0;
      height: 40px;
      border-radius: 0 0 4px 4px;
      text-align: center;
      p {
        font-size: 16px;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
/deep/ .zPanelimg {
  width: 120px !important;
  height: 120px !important;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>

<style lang="scss">
.viewer-container {
  z-index: 1000030 !important;
}
</style>
